import styles from "../styles.module.css";
import type { FC } from "react";
import type { IconButtonProps } from "@mui/material";
import { IconButton } from "@mui/material";
import { AppPopover } from "../../../AppPopover";
import { usePopover } from "../../../hooks/use-popover";
import { TrashIcon } from "../../../../shared/icons/TrashIcon";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

interface Props extends IconButtonProps {
  name: string;
  onDelete: () => void;
}

export const DeleteVersionAction: FC<Props> = ({
  name,
  onDelete,
  ...props
}) => {
  const {
    anchorPopoverEl,
    openPopover,
    handleOpenPopover,
    handleClosePopover,
  } = usePopover();
  const { t } = useTranslation();
  return (
    <>
      <IconButton
        className={classNames(styles["action-button"], {
          [styles["disabled"]]: name === undefined,
        })}
        onClick={handleOpenPopover}
        disabled={name === undefined}
        {...props}
      >
        <TrashIcon />
      </IconButton>
      <AppPopover
        open={openPopover}
        anchorEl={anchorPopoverEl}
        onClose={handleClosePopover}
        onOk={() => {
          onDelete();
          handleClosePopover();
        }}
      >
        {t("versioning.delete_popover")}
        <strong>{name}</strong>?
      </AppPopover>
    </>
  );
};
